var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndustrieImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 139,
    viewBox: "0 0 168 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_219_8622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.316 97.31H98.7388V89.8052H106.316V97.31ZM99.0963 96.9727H105.975V90.1425H99.0793V96.9727H99.0963Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.025 89.8559L98.8979 96.9155L99.1387 97.154L106.266 90.0944L106.025 89.8559Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1385 89.8509L98.8977 90.0894L106.025 97.149L106.266 96.9105L99.1385 89.8509Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.316 90.1425H98.7388V82.6377H106.316V90.1425ZM99.0963 89.8053H105.975V82.975H99.0793V89.8053H99.0963Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.035 82.6967L98.9075 89.7563L99.1483 89.9949L106.276 82.9352L106.035 82.6967Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1483 82.6966L98.9075 82.9351L106.035 89.9947L106.276 89.7562L99.1483 82.6966Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.316 82.9751H98.7388V75.4702H106.316V82.9751ZM99.0963 82.6378H105.975V75.8075H99.0793V82.6378H99.0963Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.033 75.5302L98.905 82.5898L99.1458 82.8283L106.273 75.7687L106.033 75.5302Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1458 75.5301L98.905 75.7686L106.033 82.8282L106.273 82.5897L99.1458 75.5301Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.316 75.8071H98.7388V68.3022H106.316V75.8071ZM99.0963 75.4698H105.975V68.6395H99.0793V75.4698H99.0963Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.031 68.3676L98.9036 75.4272L99.1444 75.6657L106.272 68.6061L106.031 68.3676Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1436 68.3631L98.9028 68.6016L106.03 75.6612L106.271 75.4227L99.1436 68.3631Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.316 68.6567H98.7388V61.1519H106.316V68.6567ZM99.0963 68.3194H105.975V61.4892H99.0793V68.3194H99.0963Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.028 61.1972L98.9004 68.2568L99.1412 68.4953L106.269 61.4357L106.028 61.1972Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1412 61.197L98.9004 61.4355L106.028 68.4952L106.269 68.2567L99.1412 61.197Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.316 61.4892H98.7388V53.9844H106.316V61.4892ZM99.0963 61.1519H105.975V54.3217H99.0793V61.1519H99.0963Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.026 54.0307L98.8982 61.0903L99.139 61.3288L106.267 54.2692L106.026 54.0307Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.139 54.0305L98.8982 54.269L106.026 61.3287L106.267 61.0902L99.139 54.0305Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.316 54.3217H98.7388V46.8169H106.316V54.3217ZM99.0963 53.9845H105.975V47.1542H99.0793V53.9845H99.0963Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.025 46.8681L98.8972 53.9277L99.138 54.1662L106.266 47.1066L106.025 46.8681Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1488 46.8758L98.908 47.1143L106.035 54.1739L106.276 53.9354L99.1488 46.8758Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.316 47.1538H98.7388V39.6489H106.316V47.1538ZM99.0963 46.8165H105.975V39.9862H99.0793V46.8165H99.0963Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.035 39.7128L98.907 46.7725L99.1478 47.011L106.275 39.9513L106.035 39.7128Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1463 39.7088L98.9055 39.9473L106.033 47.0069L106.274 46.7684L99.1463 39.7088Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.316 39.9863H98.7388V32.4814H106.316V39.9863ZM99.0963 39.649H105.975V32.8187H99.0793V39.649H99.0963Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.031 32.5424L98.9033 39.6021L99.1441 39.8406L106.272 32.7809L106.031 32.5424Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1441 32.5423L98.9033 32.7808L106.031 39.8404L106.272 39.6019L99.1441 32.5423Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2993 25.331H106.316V15.8867H98.9431L95.2993 19.2597V25.331Z",
    fill: "#387FF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.333 15.8867H102.774V25.3142H106.333V15.8867Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.316 32.8359H98.7388V25.3311H106.316V32.8359ZM99.0963 32.4986H105.975V25.6684H99.0793V32.4986H99.0963Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.028 25.3764L98.9009 32.436L99.1417 32.6745L106.269 25.6149L106.028 25.3764Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1417 25.3762L98.9009 25.6147L106.028 32.6744L106.269 32.4359L99.1417 25.3762Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.316 16.0551H98.7388V8.55029H106.316V16.0551ZM99.0963 15.7178H105.975V8.88759H99.0793V15.7178H99.0963Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.034 8.61073L98.906 15.6704L99.1468 15.9089L106.274 8.84924L106.034 8.61073Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1468 8.61062L98.906 8.84912L106.034 15.9088L106.274 15.6703L99.1468 8.61062Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.316 8.8874H98.7388V1.39941H106.316V8.8874ZM99.0963 8.55011H105.975V1.73671H99.0793V8.55011H99.0963Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.031 1.44374L98.9036 8.50342L99.1444 8.74192L106.272 1.68224L106.031 1.44374Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1444 1.44363L98.9036 1.68213L106.031 8.7418L106.272 8.5033L99.1444 1.44363Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.558 15.7178H49.1223V16.0551H118.558V15.7178Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5102 19.2763H50.3823V15.7178H89.5102V19.2763ZM50.7229 18.939H89.1696V16.0551H50.7229V18.939Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0876 19.3439L82.7163 16.0047L82.9547 15.7686L86.0876 18.8717L89.2206 15.7686L89.476 16.0047L86.0876 19.3439Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6345 19.3439L76.2632 16.0047L76.5016 15.7686L79.6345 18.8717L82.7675 15.7686L83.0058 16.0047L79.6345 19.3439Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1814 19.3439L69.8101 16.0047L70.0484 15.7686L73.1814 18.8717L76.3143 15.7686L76.5527 16.0047L73.1814 19.3439Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.728 19.3439L63.3567 16.0047L63.5951 15.7686L66.728 18.8717L69.861 15.7686L70.0993 16.0047L66.728 19.3439Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2578 19.3439L56.8865 16.0047L57.1419 15.7686L60.2578 18.8717L63.3908 15.7686L63.6462 16.0047L60.2578 19.3439Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8047 19.3439L50.4333 16.0047L50.6717 15.7686L53.8047 18.8717L56.9376 15.7686L57.176 16.0047L53.8047 19.3439Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8 15.8867H115.459V38.8904H115.8V15.8867Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.63 44.8606C117.366 44.8606 118.762 43.4776 118.762 41.7574C118.762 40.0372 117.366 38.6543 115.63 38.6543C113.893 38.6543 112.497 40.0372 112.497 41.7574C112.497 43.4776 113.893 44.8606 115.63 44.8606Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.975 1.39717L49.0615 15.7217L49.1563 16.0457L99.0698 1.72114L98.975 1.39717Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.276 1.4607L106.017 1.68018L118.415 16.0095L118.674 15.79L106.276 1.4607Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9938 31.5879L46.9087 114.715H69.5885L69.6567 31.5879H46.9938Z",
    fill: "#C2D6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7823 37.811H61.8923V41.8755H63.7823V37.811Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1852 37.811H57.2952V41.8755H59.1852V37.811Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6048 37.811H52.7148V41.8755H54.6048V37.811Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7823 47.5928H61.8923V51.6572H63.7823V47.5928Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1852 47.5928H57.2952V51.6572H59.1852V47.5928Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6048 47.5928H52.7148V51.6572H54.6048V47.5928Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7823 67.1729H61.8923V71.2373H63.7823V67.1729Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1852 67.1729H57.2952V71.2373H59.1852V67.1729Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6048 67.1729H52.7148V71.2373H54.6048V67.1729Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7823 57.374H61.8923V61.4384H63.7823V57.374Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1852 57.374H57.2952V61.4384H59.1852V57.374Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6048 57.374H52.7148V61.4384H54.6048V57.374Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7823 76.9541H61.8923V81.0185H63.7823V76.9541Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1852 76.9541H57.2952V81.0185H59.1852V76.9541Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6048 76.9541H52.7148V81.0185H54.6048V76.9541Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7823 86.7529H61.8923V90.8174H63.7823V86.7529Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1852 86.7529H57.2952V90.8174H59.1852V86.7529Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6048 86.7529H52.7148V90.8174H54.6048V86.7529Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2121 31.5542H69.5886V114.698H76.2121V31.5542Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3822 114.883H69.4182V21.6543H69.7588V114.546H76.0417V21.6543H76.3822V114.883Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9992 26.9331H62.6587V31.5372H62.9992V26.9331Z",
    fill: "#C2D6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8217 26.9331H53.4812V31.5372H53.8217V26.9331Z",
    fill: "#C2D6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1982 21.6543H46.8577V31.8575H47.1982V21.6543Z",
    fill: "#C2D6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8659 47.0024H90.2424L96.8659 134.649H119.052V59.4656L96.8659 47.0024Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.429 134.649H90.2424V47.0024L112.429 59.4656V134.649Z",
    fill: "#DCE0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0611 64.5754H93.0178V61.3711H95.0611V64.5754ZM93.3584 64.2381H94.7205V61.7084H93.3584V64.2381Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7049 64.5754H96.6616V61.3711H98.7049V64.5754ZM97.0022 64.2381H98.3643V61.7084H97.0022V64.2381Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.349 64.5754H100.305V61.3711H102.349V64.5754ZM100.663 64.2381H102.025V61.7084H100.663V64.2381Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.009 64.5754H103.966V61.3711H106.009V64.5754ZM104.307 64.2381H105.669V61.7084H104.307V64.2381Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.653 64.5754H107.61V61.3711H109.653V64.5754ZM107.967 64.2381H109.33V61.7084H107.967V64.2381Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0611 69.8371H93.0178V66.6328H95.0611V69.8371ZM93.3584 69.4998H94.7205V66.9701H93.3584V69.4998Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7049 69.8371H96.6616V66.6328H98.7049V69.8371ZM97.0022 69.4998H98.3643V66.9701H97.0022V69.4998Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.349 69.8371H100.305V66.6328H102.349V69.8371ZM100.663 69.4998H102.025V66.9701H100.663V69.4998Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.009 69.8371H103.966V66.6328H106.009V69.8371ZM104.307 69.4998H105.669V66.9701H104.307V69.4998Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.653 69.8371H107.61V66.6328H109.653V69.8371ZM107.967 69.4998H109.33V66.9701H107.967V69.4998Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0611 75.0989H93.0178V71.8945H95.0611V75.0989ZM93.3584 74.7616H94.7205V72.2318H93.3584V74.7616Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7049 75.0989H96.6616V71.8945H98.7049V75.0989ZM97.0022 74.7616H98.3643V72.2318H97.0022V74.7616Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.349 75.0989H100.305V71.8945H102.349V75.0989ZM100.663 74.7616H102.025V72.2318H100.663V74.7616Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.009 75.0989H103.966V71.8945H106.009V75.0989ZM104.307 74.7616H105.669V72.2318H104.307V74.7616Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.653 75.0989H107.61V71.8945H109.653V75.0989ZM107.967 74.7616H109.33V72.2318H107.967V74.7616Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0611 80.3611H93.0178V77.1567H95.0611V80.3611ZM93.3584 80.0238H94.7205V77.494H93.3584V80.0238Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7049 80.3611H96.6616V77.1567H98.7049V80.3611ZM97.0022 80.0238H98.3643V77.494H97.0022V80.0238Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.349 80.3611H100.305V77.1567H102.349V80.3611ZM100.663 80.0238H102.025V77.494H100.663V80.0238Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.009 80.3611H103.966V77.1567H106.009V80.3611ZM104.307 80.0238H105.669V77.494H104.307V80.0238Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.653 80.3611H107.61V77.1567H109.653V80.3611ZM107.967 80.0238H109.33V77.494H107.967V80.0238Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0611 85.6228H93.0178V82.4185H95.0611V85.6228ZM93.3584 85.2855H94.7205V82.7558H93.3584V85.2855Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7049 85.6228H96.6616V82.4185H98.7049V85.6228ZM97.0022 85.2855H98.3643V82.7558H97.0022V85.2855Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.349 85.6228H100.305V82.4185H102.349V85.6228ZM100.663 85.2855H102.025V82.7558H100.663V85.2855Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.009 85.6228H103.966V82.4185H106.009V85.6228ZM104.307 85.2855H105.669V82.7558H104.307V85.2855Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.653 85.6228H107.61V82.4185H109.653V85.6228ZM107.967 85.2855H109.33V82.7558H107.967V85.2855Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0611 90.8845H93.0178V87.6802H95.0611V90.8845ZM93.3584 90.5472H94.7205V88.0175H93.3584V90.5472Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7049 90.8845H96.6616V87.6802H98.7049V90.8845ZM97.0022 90.5472H98.3643V88.0175H97.0022V90.5472Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.349 90.8845H100.305V87.6802H102.349V90.8845ZM100.663 90.5472H102.025V88.0175H100.663V90.5472Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.009 90.8845H103.966V87.6802H106.009V90.8845ZM104.307 90.5472H105.669V88.0175H104.307V90.5472Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.653 90.8845H107.61V87.6802H109.653V90.8845ZM107.967 90.5472H109.33V88.0175H107.967V90.5472Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0611 96.1633H93.0178V92.959H95.0611V96.1633ZM93.3584 95.826H94.7205V93.2963H93.3584V95.826Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7049 96.1633H96.6616V92.959H98.7049V96.1633ZM97.0022 95.826H98.3643V93.2963H97.0022V95.826Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.349 96.1633H100.305V92.959H102.349V96.1633ZM100.663 95.826H102.025V93.2963H100.663V95.826Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.009 96.1633H103.966V92.959H106.009V96.1633ZM104.307 95.826H105.669V93.2963H104.307V95.826Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.653 96.1633H107.61V92.959H109.653V96.1633ZM107.967 95.826H109.33V93.2963H107.967V95.826Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0611 101.425H93.0178V98.2207H95.0611V101.425ZM93.3584 101.088H94.7205V98.558H93.3584V101.088Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7049 101.425H96.6616V98.2207H98.7049V101.425ZM97.0022 101.088H98.3643V98.558H97.0022V101.088Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.349 101.425H100.305V98.2207H102.349V101.425ZM100.663 101.088H102.025V98.558H100.663V101.088Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.009 101.425H103.966V98.2207H106.009V101.425ZM104.307 101.088H105.669V98.558H104.307V101.088Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.653 101.425H107.61V98.2207H109.653V101.425ZM107.967 101.088H109.33V98.558H107.967V101.088Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0611 106.687H93.0178V103.482H95.0611V106.687ZM93.3584 106.349H94.7205V103.82H93.3584V106.349Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7049 106.687H96.6616V103.482H98.7049V106.687ZM97.0022 106.349H98.3643V103.82H97.0022V106.349Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.349 106.687H100.305V103.482H102.349V106.687ZM100.663 106.349H102.025V103.82H100.663V106.349Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.009 106.687H103.966V103.482H106.009V106.687ZM104.307 106.349H105.669V103.82H104.307V106.349Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.653 106.687H107.61V103.482H109.653V106.687ZM107.967 106.349H109.33V103.82H107.967V106.349Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7674 138.831H39.4851L41.5624 89.4512H48.1348L56.7674 97.5126V138.831Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2119 138.831H32.9126V97.5126L41.5623 89.4512L50.2119 97.5126V138.831Z",
    fill: "#DCE0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6258 101.139H38.3442V103.399H40.6258V101.139Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7975 101.139H42.5159V103.399H44.7975V101.139Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6258 110.566H38.3442V112.826H40.6258V110.566Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7975 110.566H42.5159V112.826H44.7975V110.566Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6258 105.844H38.3442V108.104H40.6258V105.844Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7975 105.844H42.5159V108.104H44.7975V105.844Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6258 115.271H38.3442V117.531H40.6258V115.271Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7975 115.271H42.5159V117.531H44.7975V115.271Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6258 124.699H38.3442V126.959H40.6258V124.699Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7975 124.699H42.5159V126.959H44.7975V124.699Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6258 119.977H38.3442V122.236H40.6258V119.977Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7975 119.977H42.5159V122.236H44.7975V119.977Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6258 129.404H38.3442V131.664H40.6258V129.404Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7975 129.404H42.5159V131.664H44.7975V129.404Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.157 138.831H135.857L137.952 90.834H144.507L153.157 99.1652V138.831Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.584 138.831H129.302V99.1652L137.952 90.834L146.584 99.1652V138.831Z",
    fill: "#C2D6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5848 74.2222H56.1204V138.814H83.5848V74.2222Z",
    fill: "#387FF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5362 88.8438H63.1184V83.5314C63.1184 82.8737 63.6633 82.334 64.3273 82.334C64.9914 82.334 65.5362 82.8737 65.5362 83.5314V88.8438Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2311 88.8438H66.8132V83.5314C66.8132 82.8737 67.3581 82.334 68.0221 82.334C68.6862 82.334 69.2311 82.8737 69.2311 83.5314V88.8438Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9088 88.8438H70.491V83.5314C70.491 82.8737 71.0358 82.334 71.6999 82.334C72.3639 82.334 72.9088 82.8737 72.9088 83.5314V88.8438Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6036 88.8438H74.1858V83.5314C74.1858 82.8737 74.7307 82.334 75.3947 82.334C76.0588 82.334 76.6036 82.8737 76.6036 83.5314V88.8438Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5362 97.917H63.1184V92.6046C63.1184 91.9469 63.6633 91.4072 64.3273 91.4072C64.9914 91.4072 65.5362 91.9469 65.5362 92.6046V97.917Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2311 97.917H66.8132V92.6046C66.8132 91.9469 67.3581 91.4072 68.0221 91.4072C68.6862 91.4072 69.2311 91.9469 69.2311 92.6046V97.917Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9088 97.917H70.491V92.6046C70.491 91.9469 71.0358 91.4072 71.6999 91.4072C72.3639 91.4072 72.9088 91.9469 72.9088 92.6046V97.917Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6036 97.917H74.1858V92.6046C74.1858 91.9469 74.7307 91.4072 75.3947 91.4072C76.0588 91.4072 76.6036 91.9469 76.6036 92.6046V97.917Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5362 106.99H63.1184V101.678C63.1184 101.02 63.6633 100.48 64.3273 100.48C64.9914 100.48 65.5362 101.02 65.5362 101.678V106.99Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2311 106.99H66.8132V101.678C66.8132 101.02 67.3581 100.48 68.0221 100.48C68.6862 100.48 69.2311 101.02 69.2311 101.678V106.99Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9088 106.99H70.491V101.678C70.491 101.02 71.0358 100.48 71.6999 100.48C72.3639 100.48 72.9088 101.02 72.9088 101.678V106.99Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6036 106.99H74.1858V101.678C74.1858 101.02 74.7307 100.48 75.3947 100.48C76.0588 100.48 76.6036 101.02 76.6036 101.678V106.99Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5362 116.047H63.1184V110.735C63.1184 110.077 63.6633 109.537 64.3273 109.537C64.9914 109.537 65.5362 110.077 65.5362 110.735V116.047Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2311 116.047H66.8132V110.735C66.8132 110.077 67.3581 109.537 68.0221 109.537C68.6862 109.537 69.2311 110.077 69.2311 110.735V116.047Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9088 116.047H70.491V110.735C70.491 110.077 71.0358 109.537 71.6999 109.537C72.3639 109.537 72.9088 110.077 72.9088 110.735V116.047Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6036 116.047H74.1858V110.735C74.1858 110.077 74.7307 109.537 75.3947 109.537C76.0588 109.537 76.6036 110.077 76.6036 110.735V116.047Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5362 125.12H63.1184V119.808C63.1184 119.15 63.6633 118.61 64.3273 118.61C64.9914 118.61 65.5362 119.15 65.5362 119.808V125.12Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2311 125.12H66.8132V119.808C66.8132 119.15 67.3581 118.61 68.0221 118.61C68.6862 118.61 69.2311 119.15 69.2311 119.808V125.12Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9088 125.12H70.491V119.808C70.491 119.15 71.0358 118.61 71.6999 118.61C72.3639 118.61 72.9088 119.15 72.9088 119.808V125.12Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6036 125.12H74.1858V119.808C74.1858 119.15 74.7307 118.61 75.3947 118.61C76.0588 118.61 76.6036 119.15 76.6036 119.808V125.12Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5362 134.193H63.1184V128.881C63.1184 128.223 63.6633 127.684 64.3273 127.684C64.9914 127.684 65.5362 128.223 65.5362 128.881V134.193Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2311 134.193H66.8132V128.881C66.8132 128.223 67.3581 127.684 68.0221 127.684C68.6862 127.684 69.2311 128.223 69.2311 128.881V134.193Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9088 134.193H70.491V128.881C70.491 128.223 71.0358 127.684 71.6999 127.684C72.3639 127.684 72.9088 128.223 72.9088 128.881V134.193Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6036 134.193H74.1858V128.881C74.1858 128.223 74.7307 127.684 75.3947 127.684C76.0588 127.684 76.6036 128.223 76.6036 128.881V134.193Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5977 138.836H90.1531L90.1531 74.2436H83.5977L83.5977 138.836Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1572 77.6963H56.1204V78.0336H90.1572V77.6963Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5847 65.5703H80.6731V76.836H83.5847V65.5703Z",
    fill: "#387FF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1572 77.6963H56.1204V78.0336H90.1572V77.6963Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1572 71.1021H87.2456V76.8361H90.1572V71.1021Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3078 58.0654H81.9673V65.5703H82.3078V58.0654Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8632 58.0654H88.5227V71.0851H88.8632V58.0654Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1741 134.008H15.3921V138.831H38.1741V134.008Z",
    fill: "#387FF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.546 134.092H22.969V126.587H30.546V134.092ZM23.3095 133.755H30.2054V126.925H23.3095V133.755Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2686 126.628L23.0278 126.867L30.1553 133.926L30.3961 133.688L23.2686 126.628Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1558 126.627L23.0283 133.687L23.2691 133.926L30.3966 126.866L30.1558 126.627Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.546 126.925H22.969V119.42H30.546V126.925ZM23.3095 126.587H30.2054V119.757H23.3095V126.587Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2664 119.462L23.0256 119.7L30.1532 126.76L30.3939 126.521L23.2664 119.462Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1512 119.465L23.0237 126.524L23.2645 126.763L30.392 119.703L30.1512 119.465Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.546 119.757H22.969V112.252H30.546V119.757ZM23.3095 119.42H30.2054V112.59H23.3095V119.42Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.264 112.295L23.0232 112.534L30.1507 119.593L30.3915 119.355L23.264 112.295Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1512 112.294L23.0237 119.354L23.2645 119.593L30.392 112.533L30.1512 112.294Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.546 112.59H22.969V105.085H30.546V112.59ZM23.3095 112.253H30.2054V105.422H23.3095V112.253Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2738 105.14L23.033 105.379L30.1605 112.439L30.4013 112.2L23.2738 105.14Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.161 105.14L23.0334 112.2L23.2742 112.438L30.4018 105.379L30.161 105.14Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.546 105.422H22.969V97.917H30.546V105.422ZM23.3095 105.085H30.2054V98.2543H23.3095V105.085Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2716 97.9734L23.0308 98.2119L30.1583 105.272L30.3991 105.033L23.2716 97.9734Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1568 97.9765L23.0293 105.036L23.2701 105.275L30.3976 98.215L30.1568 97.9765Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.546 98.2544H22.969V90.7495H30.546V98.2544ZM23.3095 97.9171H30.2054V91.0868H23.3095V97.9171Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2694 90.8069L23.0286 91.0454L30.1561 98.1051L30.3969 97.8666L23.2694 90.8069Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1563 90.8065L23.0288 97.8662L23.2696 98.1047L30.3971 91.045L30.1563 90.8065Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.546 91.104H22.969V83.5991H30.546V91.104ZM23.3095 90.7667H30.2054V83.9364H23.3095V90.7667Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2669 83.6409L23.0261 83.8794L30.1536 90.9391L30.3944 90.7006L23.2669 83.6409Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1541 83.6405L23.0266 90.7002L23.2674 90.9387L30.3949 83.879L30.1541 83.6405Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.546 83.936H22.969V76.4312H30.546V83.936ZM23.3095 83.5987H30.2054V76.7684H23.3095V83.5987Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2647 76.4739L23.0239 76.7124L30.1514 83.7721L30.3922 83.5336L23.2647 76.4739Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1505 76.476L23.0229 83.5356L23.2637 83.7741L30.3913 76.7145L30.1505 76.476Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.546 76.7685H22.969V69.2637H30.546V76.7685ZM23.3095 76.4312H30.2054V69.601H23.3095V76.4312Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2745 69.3191L23.0337 69.5576L30.1612 76.6173L30.402 76.3788L23.2745 69.3191Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1615 69.3187L23.0339 76.3784L23.2747 76.6169L30.4023 69.5572L30.1615 69.3187Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0025 62.0964H22.9861V52.6689H30.3587L34.0025 56.0419V62.0964Z",
    fill: "#C8DBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5447 52.6689H22.9861V62.0964H26.5447V52.6689Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.546 69.601H22.969V62.0962H30.546V69.601ZM23.3095 69.2637H30.2054V62.4335H23.3095V69.2637Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2723 62.1526L23.0315 62.3911L30.159 69.4508L30.3998 69.2123L23.2723 62.1526Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1593 62.1522L23.0317 69.2119L23.2725 69.4504L30.4001 62.3907L30.1593 62.1522Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.546 52.8374H22.969V45.3325H30.546V52.8374ZM23.3095 52.5001H30.2054V45.6698H23.3095V52.5001Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2655 45.3748L23.0247 45.6133L30.1522 52.673L30.393 52.4345L23.2655 45.3748Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1514 45.3768L23.0239 52.4365L23.2647 52.675L30.3922 45.6154L30.1514 45.3768Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.546 45.6699H22.969V38.165H30.546V45.6699ZM23.3095 45.3326H30.2054V38.5023H23.3095V45.3326Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2752 38.22L23.0344 38.4585L30.1619 45.5182L30.4027 45.2797L23.2752 38.22Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1617 38.2206L23.0342 45.2803L23.275 45.5188L30.4025 38.4591L30.1617 38.2206Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5553 52.5H10.7437V52.8373H84.5553V52.5Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7255 56.0756H45.5977V52.5171H84.7255V56.0756ZM45.9382 55.7383H84.385V52.8544H45.9382V55.7383Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.02 56.1601L45.6487 52.8208L45.8871 52.5679L49.02 55.671L52.153 52.5679L52.3913 52.8208L49.02 56.1601Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4731 56.1601L52.1018 52.8208L52.3402 52.5679L55.4731 55.671L58.6061 52.5679L58.8445 52.8208L55.4731 56.1601Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9435 56.1601L58.5552 52.8208L58.8106 52.5679L61.9435 55.671L65.0595 52.5679L65.3149 52.8208L61.9435 56.1601Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3967 56.1601L65.0254 52.8208L65.2638 52.5679L68.3967 55.671L71.5297 52.5679L71.7681 52.8208L68.3967 56.1601Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8498 56.1601L71.4785 52.8208L71.7169 52.5679L74.8498 55.671L77.9828 52.5679L78.2212 52.8208L74.8498 56.1601Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.303 56.1601L77.9316 52.8208L78.17 52.5679L81.303 55.671L84.4359 52.5679L84.6743 52.8208L81.303 56.1601Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8425 52.6689H13.502V61.5399H13.8425V52.6689Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6723 67.51C11.9355 67.51 10.5393 66.1271 10.5393 64.4068C10.5393 62.6866 11.9355 61.3037 13.6723 61.3037C15.409 61.3037 16.8052 62.6866 16.8052 64.4068C16.8052 66.1102 15.409 67.51 13.6723 67.51Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4201 38.1756L30.3323 38.5015L84.5232 52.8341L84.6111 52.5082L30.4201 38.1756Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0174 38.2253L10.6177 52.5527L10.8762 52.7722L23.276 38.4448L23.0174 38.2253Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.679 34.7077L32.0444 33.0886L32.2828 32.8525L33.679 34.2355L35.0752 32.8525L35.3136 33.0886L33.679 34.7077Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2669 77.9999L8.63232 76.3809L8.8707 76.1279L10.2669 77.5108L11.6631 76.1279L11.9015 76.3809L10.2669 77.9999Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5939 1.85513L57.9763 0.236108L58.2147 0L59.5939 1.38292L60.9901 0L61.2285 0.236108L59.5939 1.85513Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.262 28.3835L133.627 26.7644L133.865 26.5283L135.262 27.9112L136.658 26.5283L136.896 26.7644L135.262 28.3835Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.119 89.2824L154.485 87.6633L154.74 87.4272L156.119 88.7933L157.516 87.4272L157.754 87.6633L156.119 89.2824Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.197 81.8281H118.967V138.831H132.197V81.8281Z",
    fill: "#387FF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.881 112.877H128.366V110.347C128.366 109.925 128.706 109.588 129.132 109.588C129.558 109.588 129.898 109.925 129.898 110.347V112.877H129.881Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.798 100.582H121.282V98.0524C121.282 97.6308 121.623 97.2935 122.049 97.2935C122.474 97.2935 122.815 97.6308 122.815 98.0524V100.582H122.798Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.339 100.582H124.824V98.0524C124.824 97.6308 125.165 97.2935 125.59 97.2935C126.016 97.2935 126.356 97.6308 126.356 98.0524V100.582H126.339Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.881 100.582H128.366V98.0524C128.366 97.6308 128.706 97.2935 129.132 97.2935C129.558 97.2935 129.898 97.6308 129.898 98.0524V100.582H129.881Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.798 94.4263H121.282V91.8966C121.282 91.475 121.623 91.1377 122.049 91.1377C122.474 91.1377 122.815 91.475 122.815 91.8966V94.4263H122.798Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.339 94.4263H124.824V91.8966C124.824 91.475 125.165 91.1377 125.59 91.1377C126.016 91.1377 126.356 91.475 126.356 91.8966V94.4263H126.339Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.881 94.4263H128.366V91.8966C128.366 91.475 128.706 91.1377 129.132 91.1377C129.558 91.1377 129.898 91.475 129.898 91.8966V94.4263H129.881Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.798 88.2706H121.282V85.7409C121.282 85.3192 121.623 84.9819 122.049 84.9819C122.474 84.9819 122.815 85.3192 122.815 85.7409V88.2706H122.798Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.339 88.2706H124.824V85.7409C124.824 85.3192 125.165 84.9819 125.59 84.9819C126.016 84.9819 126.356 85.3192 126.356 85.7409V88.2706H126.339Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.881 88.2706H128.366V85.7409C128.366 85.3192 128.706 84.9819 129.132 84.9819C129.558 84.9819 129.898 85.3192 129.898 85.7409V88.2706H129.881Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.798 106.737H121.282V104.208C121.282 103.786 121.623 103.449 122.049 103.449C122.474 103.449 122.815 103.786 122.815 104.208V106.737H122.798Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.339 106.737H124.824V104.208C124.824 103.786 125.165 103.449 125.59 103.449C126.016 103.449 126.356 103.786 126.356 104.208V106.737H126.339Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.881 106.737H128.366V104.208C128.366 103.786 128.706 103.449 129.132 103.449C129.558 103.449 129.898 103.786 129.898 104.208V106.737H129.881Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.881 119.032H128.366V116.502C128.366 116.08 128.706 115.743 129.132 115.743C129.558 115.743 129.898 116.08 129.898 116.502V119.032H129.881Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.881 131.343H128.366V128.814C128.366 128.392 128.706 128.055 129.132 128.055C129.558 128.055 129.898 128.392 129.898 128.814V131.343H129.881Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.881 125.188H128.366V122.658C128.366 122.236 128.706 121.899 129.132 121.899C129.558 121.899 129.898 122.236 129.898 122.658V125.188H129.881Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.752 81.8281H132.197V138.831H138.752V81.8281Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.167 134.092H136.59V126.587H144.167V134.092ZM136.93 133.755H143.826V126.925H136.93V133.755Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.864 126.63L136.737 133.689L136.977 133.928L144.105 126.868L143.864 126.63Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.978 126.639L136.737 126.877L143.864 133.937L144.105 133.699L136.978 126.639Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.167 126.925H136.59V119.42H144.167V126.925ZM136.93 126.587H143.826V119.757H136.93V126.587Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.862 119.47L136.735 126.53L136.975 126.768L144.103 119.709L143.862 119.47Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.975 119.472L136.735 119.711L143.862 126.771L144.103 126.532L136.975 119.472Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.167 119.757H136.59V112.252H144.167V119.757ZM136.93 119.42H143.826V112.59H136.93V119.42Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.859 112.297L136.732 119.357L136.972 119.595L144.1 112.536L143.859 112.297Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.973 112.306L136.732 112.544L143.86 119.604L144.101 119.366L136.973 112.306Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.167 112.59H136.59V105.085H144.167V112.59ZM136.93 112.253H143.826V105.422H136.93V112.253Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.869 105.143L136.741 112.203L136.982 112.441L144.11 105.381L143.869 105.143Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.983 105.151L136.742 105.39L143.87 112.449L144.111 112.211L136.983 105.151Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.167 105.422H136.59V97.917H144.167V105.422ZM136.93 105.085H143.826V98.2543H136.93V105.085Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.867 97.9823L136.74 105.042L136.981 105.28L144.108 98.2208L143.867 97.9823Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.981 97.9842L136.74 98.2227L143.868 105.282L144.108 105.044L136.981 97.9842Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.167 98.2544H136.59V90.7495H144.167V98.2544ZM136.93 97.9171H143.826V91.0868H136.93V97.9171Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.864 90.81L136.736 97.8696L136.977 98.1081L144.104 91.0485L143.864 90.81Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.979 90.8172L136.738 91.0557L143.865 98.1153L144.106 97.8768L136.979 90.8172Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.167 91.104H136.59V83.5991H144.167V91.104ZM136.93 90.7667H143.826V83.9364H136.93V90.7667Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.861 83.6439L136.734 90.7036L136.974 90.9421L144.102 83.8824L143.861 83.6439Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.976 83.6511L136.736 83.8896L143.863 90.9493L144.104 90.7108L136.976 83.6511Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.167 83.936H136.59V76.4312H144.167V83.936ZM136.93 83.5987H143.826V76.7684H136.93V83.5987Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.86 76.4823L136.733 83.542L136.973 83.7805L144.101 76.7208L143.86 76.4823Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.974 76.4842L136.733 76.7227L143.861 83.7823L144.101 83.5438L136.974 76.4842Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.167 76.7685H136.59V69.2637H144.167V76.7685ZM136.93 76.4312H143.826V69.601H136.93V76.4312Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.868 69.3226L136.741 76.3823L136.982 76.6208L144.109 69.5612L143.868 69.3226Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.984 69.3294L136.743 69.5679L143.87 76.6275L144.111 76.389L136.984 69.3294Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.133 62.0964H144.149V52.6689H136.777L133.133 56.0419V62.0964Z",
    fill: "#C8DBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.149 52.6689H142.379V62.0964H144.149V52.6689Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.167 69.601H136.59V62.0962H144.167V69.601ZM136.93 69.2637H143.826V62.4335H136.93V69.2637Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.866 62.1566L136.738 69.2163L136.979 69.4548L144.107 62.3951L143.866 62.1566Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.982 62.1634L136.741 62.4019L143.868 69.4615L144.109 69.223L136.982 62.1634Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.167 52.8374H136.59V45.3325H144.167V52.8374ZM136.93 52.5001H143.826V45.6698H136.93V52.5001Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.861 45.3842L136.733 52.4438L136.974 52.6824L144.101 45.6227L143.861 45.3842Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.974 45.3841L136.733 45.6226L143.861 52.6822L144.101 52.4437L136.974 45.3841Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.167 45.6699H136.59V38.165H144.167V45.6699ZM136.93 45.3326H143.826V38.5023H136.93V45.3326Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.868 38.225L136.74 45.2847L136.981 45.5232L144.109 38.4635L143.868 38.225Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.983 38.2293L136.743 38.4678L143.87 45.5274L144.111 45.2889L136.983 38.2293Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.375 52.5H117.536V52.8373H156.375V52.5Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.111 56.0756H118.813V52.5171H132.111V56.0756ZM119.154 55.7383H131.771V52.8544H119.154V55.7383Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.689 56.1601L125.318 52.8208L125.556 52.5679L128.689 55.671L131.822 52.5679L132.06 52.8208L128.689 56.1601Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.236 56.1601L118.865 52.8208L119.103 52.5679L122.236 55.671L125.369 52.5679L125.607 52.8208L122.236 56.1601Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.634 52.6689H153.293V61.5399H153.634V52.6689Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.463 67.51C155.2 67.51 156.596 66.1271 156.596 64.4068C156.596 62.6866 155.2 61.3037 153.463 61.3037C151.727 61.3037 150.33 62.6866 150.33 64.4068C150.33 66.1102 151.727 67.51 153.463 67.51Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.967 138.825H151.749V134.002H128.967V138.825Z",
    fill: "#DCE0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.848 109.014H83.5508V138.831H118.848V109.014Z",
    fill: "#C8DBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.969 127.684H90.7021V138.831H111.969V127.684Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.55 134.396H97.5469V134.733H120.55V134.396Z",
    fill: "#C8DBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.758 135.88H94.7544V136.217H117.758V135.88Z",
    fill: "#C8DBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.342 132.912H100.339V133.249H123.342V132.912Z",
    fill: "#C8DBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.118 131.444H103.115V131.782H126.118V131.444Z",
    fill: "#C8DBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.91 129.96H105.907V130.298H128.91V129.96Z",
    fill: "#C8DBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.982 137.347H91.979V137.684H114.982V137.347Z",
    fill: "#C8DBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.471 109.014H118.916V138.831H125.471V109.014Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.471 123.383H83.6189V123.72H125.471V123.383Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6681 112.96H88.3865V115.22H90.6681V112.96Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3846 112.96H93.103V115.22H95.3846V112.96Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.118 112.96H97.8364V115.22H100.118V112.96Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.301 112.96H112.02V115.22H114.301V112.96Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.851 112.96H102.57V115.22H104.851V112.96Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.568 112.96H107.286V115.22H109.568V112.96Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6681 117.48H88.3865V119.74H90.6681V117.48Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3846 117.48H93.103V119.74H95.3846V117.48Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.118 117.48H97.8364V119.74H100.118V117.48Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.301 117.48H112.02V119.74H114.301V117.48Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.851 117.48H102.57V119.74H104.851V117.48Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.568 117.48H107.286V119.74H109.568V117.48Z",
    fill: "#000021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.157 138.663H15.3921V140.078H153.157V138.663Z",
    fill: "#000021"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_219_8622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167,
    height: 139,
    fill: "white",
    transform: "translate(0.0678711)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustrieImg);
export default __webpack_public_path__ + "static/media/industrieImg.b70e265268122d076bf6849ed1622d8e.svg";
export { ForwardRef as ReactComponent };